module.exports = __webpack_public_path__ + "static/media/columbia_university.8b8c8061.jpg";